import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Alert.module.css';

const Alert = ({
  type = 'error',  // error, success, info, warning
  message,
  title,
  onClose,
  icon
}) => {
  const [closing, setClosing] = useState(false);

  // Define o ícone baseado no tipo
  const getIcon = () => {
    if (icon) return icon;

    switch (type) {
      case 'error': return <i className="fas fa-exclamation-circle"></i>;
      case 'success': return <i className="fas fa-check-circle"></i>;
      case 'info': return <i className="fas fa-info-circle"></i>;
      case 'warning': return <i className="fas fa-exclamation-triangle"></i>;
      default: return <i className="fas fa-bell"></i>;
    }
  };

  const handleClose = () => {
    setClosing(true);

    // Aguardar a animação terminar antes de remover
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // 300ms é a duração da animação
  };

  return (
    <div className={`${styles.alert} ${styles[type]} ${closing ? styles.closing : ''}`}>
      <div className={styles.iconContainer}>
        {getIcon()}
      </div>
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.message}>{message}</div>
      </div>
      {onClose && (
        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Fechar"
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['error', 'success', 'info', 'warning']),
  message: PropTypes.string.isRequired,
  title: PropTypes.string, 
  onClose: PropTypes.func,
  icon: PropTypes.node 
};

Alert.defaultProps = {
  type: 'error'
};

export default Alert;